import { Check } from "lucide-react";
import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { LeadForm } from "../components/LeadForm";

const SOLUTIONS = [
  { title: "Bilgece Okul", desc: "Bilgelik Pedagojisi + öğretmen + ebeveyn + öğrenci yaklaşımını kurum kültürüne entegre eden bütünsel model." },
  { title: "Bilgece Matematik Yetkili Uygulama Merkezi", desc: "Kurumunuzda 10–14 yaş için gerçek yaşam bağlantılı Bilgece Matematik programını uygulama yetkisi." },
  { title: "Bilgece Öğretmenlik Akademisi", desc: "Öğretmen kadronuz için AI çağına uygun, öğrenciyi ve öğrenmeyi merkeze alan gelişim programı." },
  { title: "Bilgece Liderlik & Kurum Kültürü", desc: "Yöneticiler ve liderler için etik, insan odaklı ve anlam üreten liderlik gelişimi." },
];

const AUDIENCE = ["Okullar", "Kurs merkezleri", "Üniversiteler", "Vakıflar", "Şirketler", "Eğitim kuruluşları"];
const PROGRAMS = ["Bilgece Okul", "Bilgece Matematik Yetkili Uygulama Merkezi", "Bilgece Öğretmenlik Akademisi", "Bilgece Liderlik & Kurum Kültürü"];

export default function Kurumlar() {
  return (
    <>
      <Seo title="Kurumlar İçin" description="Okullar, kurslar, üniversiteler, vakıflar ve şirketler için Bilgece kurumsal çözümleri. Bilgece Okul, Matematik uygulama merkezi, öğretmenlik akademisi ve liderlik." />
      <section className="pt-36 pb-16 bg-brand-green text-brand-offwhite grain relative overflow-hidden">
        <div className="container-narrow px-6 lg:px-10">
          <p className="text-xs uppercase tracking-[0.25em] text-brand-gold font-semibold mb-4">Kurumlar İçin</p>
          <h1 className="font-serif text-4xl md:text-6xl font-light max-w-3xl">Kurumunuzu bilgece bir öğrenme kültürüne taşıyın</h1>
          <p className="text-brand-offwhite/75 mt-6 max-w-2xl leading-relaxed">Okullar, kurslar, üniversiteler, vakıflar ve şirketler için Bilgelik Pedagojisi temelli kurumsal çözümler.</p>
          <div className="flex flex-wrap gap-2 mt-8">
            {AUDIENCE.map((a) => <span key={a} className="bg-brand-green2 border border-brand-offwhite/15 px-4 py-2 rounded-full text-sm">{a}</span>)}
          </div>
        </div>
      </section>

      <section className="section-pad bg-brand-offwhite">
        <div className="container-narrow">
          <Reveal><h2 className="font-serif text-3xl md:text-5xl text-brand-green mb-12">Ana çözümler</h2></Reveal>
          <div className="grid md:grid-cols-2 gap-8">
            {SOLUTIONS.map((s, i) => (
              <Reveal key={i} delay={(i % 2) * 0.1}>
                <div className="h-full bg-brand-cream border border-brand-gold-light/40 rounded-sm p-8">
                  <Check className="text-brand-gold" size={26} />
                  <h3 className="font-serif text-2xl md:text-3xl text-brand-green mt-4">{s.title}</h3>
                  <p className="text-brand-text/70 mt-3 leading-relaxed">{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section-pad bg-brand-cream">
        <div className="container-narrow max-w-3xl">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.25em] text-brand-gold font-semibold mb-3">Kurumsal Görüşme</p>
            <h2 className="font-serif text-3xl md:text-5xl text-brand-green mb-3">Kurumsal görüşme talep et</h2>
            <p className="text-brand-text/70 mb-8">İhtiyaçlarınızı dinleyelim, kurumunuza özel bir yol haritası çıkaralım.</p>
          </Reveal>
          <div className="bg-brand-offwhite border border-brand-gold-light/40 rounded-sm p-8 md:p-10">
            <LeadForm
              testid="institutional-form"
              source="institutional"
              fields={["name", "organization", "email", "phone", "city", "program", "message"]}
              programs={PROGRAMS}
              submitLabel="Kurumsal Görüşme Talep Et"
              onStarted={() => import("../lib/analytics").then(({ track }) => track("institutional_form_started"))}
              onCompleted={() => import("../lib/analytics").then(({ track }) => track("institutional_form_completed"))}
            />
          </div>
        </div>
      </section>
    </>
  );
}
